import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import createPersistedstate from 'vuex-persistedstate'
import { getCurrentMenuByUser } from '@/api/System/Menu'

import { menuList2Tree } from '@/utils/'

import Layout from '@/layout/index'
import EmptyRouter from '@/layout/EmptyRouter'
import _ from 'lodash'

const loadView = (view) => {
  // 路由懒加载
  return () => import('@/views' + view)
}

function filterAsyncRouter(menus) {
  menus.sort((a, b) => {
    return a.orderNum - b.orderNum
  })
  for (let item of menus) {
    if (item.componentPath == 'Layout') {
      item.component = Layout
    } else if (item.componentPath == 'Empty') {
      item.component = EmptyRouter
    } else {
      item.component = loadView(item.componentPath)
    }
    item.name = item.path
    item.path = '/' + item.path
    item.meta = {
      icon: item.icon,
      title: item.menuName
    }
    if (item.children && Array.isArray(item.children)) {
      filterAsyncRouter(item.children)
    }
  }
}

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loading: false,
    loadingText: '加载中...',
    token: '',
    name: '',
    roles: [],
    tagViews: [
      {
        id: '/home',
        name: 'home',
        fullPath: '/home',
        meta: {
          icon: 'home',
          title: '首页'
        },
        query: {}
      }
    ],
    userInfo: {},
    menus: [],
    // 个性化设置 依赖vuex的本地持久化工作 如果需要替换掉createPersistedstate插件,自行实现相关功能
    userIndividualizationSettings: {},
    installed: false,
    paramManage: {}
  },
  mutations: {
    SET_PARAM: (state, installed) => {
      state.paramManage = installed
    },
    SET_INSTALL: (state, installed) => {
      state.installed = installed
    },
    SET_LOADING: (state, { loading, text = '加载中...' }) => {
      state.loading = loading
      state.loadingText = text
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    INIT_MENUS: (state, data) => {
      let menus = data.filter((item) => item.isHide == '-1')
      menus = menuList2Tree(menus)
      filterAsyncRouter(menus)
      state.menus = menus
    },
    ADD_TAG_VIEWS: (state, route) => {
      let res = state.tagViews.filter((item) => {
        return item.id == route.id
      })
      if (res.length == 0) {
        state.tagViews.push(route)
      }
    },
    SET_TAG_VIEWS: (state, tags) => {
      state.tagViews = tags
    },
    Set_Individualization_Setting: (state, { key, value }) => {
      state.userIndividualizationSettings[key] = value
    }
  },
  actions: {
    GenerateRoutes({ commit }) {
      return new Promise((resolve) => {
        getCurrentMenuByUser().then((res) => {
          let { code, data } = res
          if (code == '200') {
            commit('INIT_MENUS', _.cloneDeep(data))
            data = menuList2Tree(data)
            data.sort((a, b) => {
              return a.orderNum - b.orderNum
            })
            // data[3].meta.alive = true
            filterAsyncRouter(data)
            resolve(data)
          } else {
            commit('INIT_MENUS', [])
          }
        })
      })
    }
  },
  modules: {},
  getters,
  plugins: [createPersistedstate({})]
})

export default store
